import createButton from './buttonFactory';

const primaryStyles =
  'border border-white/20 bg-[var(--accent-primary)] text-white font-semibold shadow-[0_28px_70px_-32px_rgba(127,184,232,0.65)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[var(--accent-secondary)] hover:shadow-[0_38px_90px_-40px_rgba(127,184,232,0.65)] focus-visible:ring-[rgba(161,196,253,0.55)]';

const PrimaryButton = createButton(primaryStyles, 'PrimaryButton');

export default PrimaryButton;
